import model from './model';
import { SectionsController } from './sectionsController';
import type { SectionWidgetProps } from '../../types/menusTypes';
import type { TFunction } from '@wix/yoshi-flow-editor';
import { hasDataChanged } from 'root/utils/utils';
import { DEFAULT_TIMEZONE } from 'root/api/consts';
import { getSiteLanguage } from 'root/utils/siteDataUtils';

export default model.createController(({ $w, $widget, flowAPI }) => {
  const t = flowAPI.translations.t as TFunction;
  const { isEditor } = flowAPI.environment;
  const { wixCodeApi } = flowAPI.controllerConfig;
  const timezone = wixCodeApi.site.timezone || DEFAULT_TIMEZONE;
  const language = getSiteLanguage(flowAPI);
  const sectionsController = new SectionsController(
    $w,
    t,
    isEditor,
    timezone,
    language,
    flowAPI.experiments
  );
  let didInit = false;

  $widget.onPropsChanged((prevProps, nextProps) => {
    const { sections, menuId } = nextProps.data;
    const shouldInit = hasDataChanged({
      prevData: prevProps.data?.sections,
      nextData: sections,
    });

    if (shouldInit) {
      if (sections.length > 0) {
        if (!didInit) {
          didInit = true;
          sectionsController.init(sections, menuId);
        } else {
          sectionsController.setSections(sections);
        }
      } else {
        sectionsController.setEmptyState();
      }
    }
  });

  return {
    pageReady: async () => {
      $widget.fireEvent('widgetLoaded', {});
      const { sections, menuId }: SectionWidgetProps = $widget.props.data;
      if (sections.length > 0) {
        if (!didInit) {
          didInit = true;
          sectionsController.init(sections, menuId);
        } else {
          sectionsController.setSections(sections);
        }
      } else {
        sectionsController.setEmptyState();
      }
    },
    exports: {},
  };
});
